import { Alert, Anchor, Box, Heading, Paragraph, TextButton } from '@zillow/constellation-10';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import { CreditScoreBar } from './CreditReportScoreBar';
import { CreditReportScoreFactors } from './CreditReportScoreFactors';
import {
  CREDIT_SCORE_EXCLUSION_CODES,
  CREDIT_SCORE_LACK_OF_INFORMATION,
  getNumberFromString,
  NO_CREDIT_SCORE_ZENDESK_URL,
  VANTAGE_SCORE_URL,
} from '@zg-rentals/applications-utils';

export function CreditReportScore({ creditReport }: { creditReport: CreditReportType }) {
  const creditScore = getNumberFromString(creditReport.creditScore);
  const riskModels = creditReport.fullCreditProfile?.RiskModel;
  const riskModel = riskModels && riskModels.length ? riskModels[0] : null;
  const riskModelIndicator = riskModel?.ModelIndicator?.desc;
  return creditScore === CREDIT_SCORE_LACK_OF_INFORMATION ? (
    <Alert
      role="status"
      actionButton={
        <TextButton asChild>
          <a href={NO_CREDIT_SCORE_ZENDESK_URL} rel="noreferrer" target="_blank">
            Learn more
          </a>
        </TextButton>
      }
    >
      There isn’t enough credit history available to generate a credit report.
    </Alert>
  ) : (
    <>
      <Heading level={3} textStyle="heading-sm" css={{ marginTop: 'md' }}>
        Credit score
      </Heading>

      {creditScore && !CREDIT_SCORE_EXCLUSION_CODES.includes(creditScore) ? (
        <>
          <CreditScoreBar creditScore={creditScore} />
          {riskModelIndicator && (
            <Box css={{ display: 'flex', justifyContent: 'center' }}>
              <Paragraph textStyle="body-xs">
                Calculated using{' '}
                <Anchor href={VANTAGE_SCORE_URL} target="_blank">
                  {riskModelIndicator}
                </Anchor>
              </Paragraph>
            </Box>
          )}
          {riskModel && <CreditReportScoreFactors riskModel={riskModel} />}
        </>
      ) : (
        <Paragraph textStyle="body-sm">No score available. Unable to calculate score.</Paragraph>
      )}
    </>
  );
}
